import { composePercentValue, composeWithPerAnnum } from '@pbk/utils';
export const composePercentValuePerAnnum = (value, locale, precision = 2) => {
    const percentValue = composePercentValue({ value, precision, locale });
    return composeWithPerAnnum(percentValue);
};
